<template>
    <div class="mb-4">
        <b-form-group :state="false">
            <b-card :class="v.$invalid ? 'form-invalid' : 'form-valid'" no-body>
                <b-card-body>
                    <b-table id="my-table" :fields="fields" :items="items" class="table-atmo mb-0" show-empty small responsive>
                        <template #head(actions)>
                            <action-button-small icon="plus-square" @click="addItem" title="Добавить описание требования" />
                        </template>
                        <template #cell(index)="data">
                            {{ data.index + 1 }}
                        </template>
                        <template #cell(description)="data">
                            <b-form-input v-model="data.item.description" class="mb-0 form-control fs-14" :class="!v.$each[data.index].description.$invalid ? 'is-valid' : 'is-invalid'" />
                        </template>
                        <template #cell(reason)="data">
                            <b-form-input v-model="data.item.reason" class="mb-0 form-control fs-14" :class="!v.$each[data.index].reason.$invalid ? 'is-valid' : 'is-invalid'" />
                        </template>
                        <template #cell(actions)="data">
                            <action-button-small icon="trash" @click="removeItem(data.index)" title="Удалить" />
                        </template>
                        <template #empty>
                            <div class="w-100 text-center text-danger">Добавьте описание требования</div>
                        </template>
                    </b-table>
                </b-card-body>
            </b-card>
        </b-form-group>
    </div>
</template>

<script>

export default {
    name: 'additional-supplier-requirements-edit-table',
    props: {
        value: {
            type: Array,
            required: true
        },
        v: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            fields: [
                { key: 'index', label: '№', tdClass: 'align-text-top text-nowrap py-1', thClass: 'py-1', thStyle: { width: '1px' } },
                { key: 'description', label: 'Описание', tdClass: 'align-text-top py-1 text-nowrap', thClass: 'py-1', thStyle: { width: '50%' } },
                { key: 'reason', label: 'Причина или цель установки требования', tdClass: 'align-text-top py-1 text-nowrap', thClass: 'py-1', thStyle: { width: '50%' } },
                { key: 'actions', thStyle: 'width: 1px;', tdClass: 'text-right py-1', thClass: 'py-1' }
            ],
            showSignModal: false,
            signData: {
                signature: null,
                isCustomer: false
            }
        };
    },
    methods: {
        addItem() {
            this.items.push({ description: null, reason: null });
        },
        removeItem(index) {
            this.items.splice(index, 1);
        }
    },
    computed: {
        items: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value);
            }
        }
    }
};
</script>

<style scoped>
.form-invalid {
    border: 1px solid #dc3545;
}
.form-valid {
    border: 1px solid var(--green-color);
}
</style>
